<script lang="ts">
import TransitionWidth from "@/Components/Generics/TransitionWidth.vue";
import { defineComponent } from "vue";

export default defineComponent({
    components: {
        TransitionWidth,
    },
    props: {
        values: {
            type: Array,
            required: true,
        },
        selectedIndex: {
            type: Number,
            default: 0,
        },

        roundabout: {
            type: Boolean,
            default: false,
        },
    },
    emits: ["changeValue"],
    data: () => ({}),
    computed: {
        selectedItem() {
            if (!this.values || this.values.length < 1) return null;

            return this.values[this.selectedIndex];
        },

        leftDisabled() {
            if (!this.values) return true;

            if (this.roundabout) return false;

            return this.selectedIndex <= 0;
        },
        rightDisabled() {
            if (!this.values) return true;

            if (this.roundabout) return false;

            return this.selectedIndex >= (this.values?.length ?? 1) - 1;
        },
    },
    methods: {
        clickRight() {
            let newVal = this.selectedIndex + 1;

            if (newVal > (this.values?.length ?? 1) - 1) {
                if (this.roundabout) newVal = 0;
                else return;
            }

            this.$emit("changeValue", newVal);
        },
        clickLeft() {
            let newVal = this.selectedIndex - 1;

            if (newVal < 0) {
                if (this.roundabout) newVal = (this.values?.length ?? 1) - 1;
                else return;
            }

            this.$emit("changeValue", newVal);
        },
    },
});
</script>

<template>
    <!-- <TransitionWidth> -->
    <div class="carousel-button flex flex--valign-c flex--halign-c flex--gap-20">
        <button class="carousel-button-icon text text--size-32 text--extra-bold text--accent-gray-a text--uppercase" :disabled="leftDisabled" @click="clickLeft">{{ "<" }}</button>

        <TransitionWidth>
            <span class="carousel-button-title">
                <Transition name="generic-fade" mode="out-in">
                    <span :key="selectedIndex" class="carousel-button-title-inner text text--size-20 text--semi-bold text--primary-b text--uppercase text--less-gap">
                        <slot name="title" :selected-item="selectedItem">
                            {{ "No title" }}
                        </slot>
                    </span>
                </Transition>
            </span>
        </TransitionWidth>

        <button class="carousel-button-icon text text--size-32 text--extra-bold text--accent-gray-a text--uppercase" :disabled="rightDisabled" @click="clickRight">{{ ">" }}</button>
    </div>
    <!-- </TransitionWidth> -->
</template>

<style lang="scss" scoped>
.carousel-button {
    padding-left: rem(15);
    padding-right: rem(15);
    border-radius: rem(25);
    min-height: rem(45);
    height: auto;
    pointer-events: all;
    background-color: $color-accent-light-a;

    .carousel-button-icon {
        border: none;
        background: none;
        transform: scale(1.25) scaleX(0.8);

        &:disabled {
            opacity: 0.2;
        }

        &:hover:not(:disabled) {
            color: $color-primary-b;
        }
    }

    .carousel-button-title {
        display: inline-flex;
        justify-content: center;
        align-items: center;
        min-width: 0;
        // white-space: nowrap;

        .carousel-button-title-inner {
            display: block;
            text-align: center;
            white-space: normal;
            overflow-wrap: normal;
            text-wrap: balance;
        }
    }
}

@include media-breakpoint-down(md) {
    .carousel-button {
        min-height: rem(60);
        padding-top: rem(8);
        padding-bottom: rem(8);
        min-height: rem(40);
        gap: rem(10);

        .carousel-button-title {
            max-width: rem(230);
            min-width: 0;
        }

        .carousel-button-title-inner {
            line-height: 1.1;
        }
    }
}

@include media-breakpoint-down(sm) {
    .carousel-button {
        padding-left: rem(10);
        padding-right: rem(10);
        // border-radius: rem(25);
        min-height: rem(35);
    }
}
</style>
